import { createContext, useContext, type MutableRefObject, type ReactNode } from 'react';

interface SettingsPanelContextValue {
  pushView: (view: ReactNode) => void;
  popView: () => void;
  backHandlerRef: MutableRefObject<(() => void) | null>;
}

const SettingsPanelContext = createContext<SettingsPanelContextValue | null>(null);

export function useSettingsPanelContext(): SettingsPanelContextValue {
  const context = useContext(SettingsPanelContext);
  if (!context) {
    throw new Error('useSettingsPanelContext must be used within a ChatSettingsPanel');
  }
  return context;
}

export function useSettingsPanelContextSafe(): SettingsPanelContextValue | null {
  return useContext(SettingsPanelContext);
}

export { SettingsPanelContext };
